"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryTotalSection = void 0;
const react_1 = __importDefault(require("react"));
const IconChevronDown_1 = require("../../icons/IconChevronDown");
const IconChevronUp_1 = require("../../icons/IconChevronUp");
const IconShoppingCart_1 = require("../../icons/IconShoppingCart");
const NumericFormatTwoDecimals_1 = require("../../numeric-format/NumericFormatTwoDecimals");
const SummaryTotalSection = (props) => {
    let toggle;
    if (props.open) {
        toggle = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IconShoppingCart_1.IconShoppingCart, null),
            " ",
            react_1.default.createElement("span", { className: "d-none d-sm-inline" }, "Buchungs\u00FCbersicht "),
            "verbergen",
            " ",
            react_1.default.createElement(IconChevronUp_1.IconChevronUp, null)));
    }
    else {
        toggle = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IconShoppingCart_1.IconShoppingCart, null),
            " ",
            react_1.default.createElement("span", { className: "d-none d-sm-inline" }, "Buchungs\u00FCbersicht "),
            "anzeigen",
            " ",
            react_1.default.createElement(IconChevronDown_1.IconChevronDown, null)));
    }
    const calculatedPrices = props.booking.calcTotals();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", { className: "d-md-none" },
            react_1.default.createElement("td", { className: "text-primary" },
                react_1.default.createElement("a", { href: "#", className: "stretched-link text-decoration-none", onClick: props.onToggle }, toggle)),
            react_1.default.createElement("td", { className: "font-weight-bold text-right" }),
            react_1.default.createElement("td", { className: "text-right font-weight-bold text-nowrap" },
                react_1.default.createElement("small", null, "Total inkl. MWST"),
                " CHF",
                " ",
                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: calculatedPrices.totalPrice }))),
        react_1.default.createElement("tr", { className: "d-none d-md-block" },
            react_1.default.createElement("td", { className: "font-weight-bold text-nowrap" },
                "Total ",
                react_1.default.createElement("small", null, "inkl. MWST")),
            react_1.default.createElement("td", null),
            react_1.default.createElement("td", { className: "text-right font-weight-bold text-nowrap w-100" },
                "CHF ",
                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: calculatedPrices.totalPrice })))));
};
exports.SummaryTotalSection = SummaryTotalSection;
